// extracted by mini-css-extract-plugin
module.exports = {"container":"SafeEmailAdd_container_12m2V","goBack":"SafeEmailAdd_goBack_VkpVe"};